import { Category } from "@/types";


export type NextAction =
  | { kind: "drilldown" }                                     // fetch next level
  | { kind: "navigate"; to: string; replace?: boolean };

export interface ICategoryStrategy {
    useUrlDepth?: boolean;
    autoSelectSingleCategory?: boolean;
    fetchCategories(slug: string): Promise<Category[]>;
    onLeafCategorySelected(category?: Category): NextAction;
    getNextAction(category: Category): NextAction | Promise<NextAction>;
}
